import { ERROR_SORT_BRAND_LINES, START_SORT_BRAND_LINES, SUCCESS_SORT_BRAND_LINES } from "../types";


export const startSortBrandLines = (payload) => ({
  type: START_SORT_BRAND_LINES,
  payload,
});

export const successSortBrandLines = () => ({
  type: SUCCESS_SORT_BRAND_LINES,
});

export const errorSortBrandLines = (error) => ({
  type: ERROR_SORT_BRAND_LINES,
  error,
});
